import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { useEffect } from "react";

import { Link } from "react-router-dom";
import ChapterNav from "./components/ChapterNav";
import Butterflies from "./components/Butterflies";
import PeekAMoo from "./components/PeekAMoo";
import PageTransition from "./components/PageTransition";
import CowbellAdmin from "./components/CowbellAdmin";

import Welcome from "./pages/Welcome";
import LilSalties from "./pages/LilSalties";
import MeetTheHerd from "./pages/MeetTheHerd";
import LookingForNewPastures from "./pages/LookingForNewPastures";
import SaltieBrays from "./pages/SaltieBrays";
import SaltieMoos from "./pages/SaltieMoos";
import SaltieFunFacts from "./pages/SaltieFunFacts";
import Coloring from "./pages/Coloring";
import MeetTheFamily from "./pages/MeetTheFamily";
import FrontPorch from "./pages/FrontPorch";
import SaltBlock from "./pages/SaltBlock";
import SaltieWinks from "./pages/SaltieWinks";
import SaltieShoutOuts from "./pages/SaltieShoutOuts";
import HisStory from "./pages/HisStory";
import StoryBarn from "./pages/StoryBarn";
import OrderComplete from "./pages/OrderComplete";
import Admin from "./pages/Admin";
import AdminSubscribers from "./pages/AdminSubscribers";
import AdminCowmunity from "./pages/AdminCowmunity";
import OurCowmunity from "./pages/OurCowmunity";
import MooVelous from "./pages/MooVelous";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import NotFound from "./pages/NotFound";
import QRLanding from "./pages/QRLanding";
import QRGenerator from "./pages/QRGenerator";
import Unsubscribe from "./pages/Unsubscribe";
import Footer from "./components/Footer";

/**
 * Reset scroll position to the top on every route change so a reader
 * always begins a new chapter at page top — no lingering scroll offset
 * carried over from the previous chapter.
 */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function StoryShell() {
  const { pathname } = useLocation();
  const isWelcome = pathname === "/";
  return (
    <>
      <Butterflies gutters={pathname.startsWith("/story-barn")} />
      {!isWelcome && <ChapterNav />}
      {!isWelcome && <PeekAMoo />}
      <CowbellAdmin />
      <main id="main-content" tabIndex={-1}>
        <PageTransition>
          <Routes>
            <Route path="/" element={<Welcome />} />
            <Route path="/lil-salties" element={<LilSalties />} />
            <Route path="/meet-the-herd" element={<MeetTheHerd />} />
            <Route path="/looking-for-new-pastures" element={<LookingForNewPastures />} />
            <Route path="/saltie-brays" element={<SaltieBrays />} />
            <Route path="/saltie-moos" element={<SaltieMoos />} />
            <Route path="/saltie-winks" element={<SaltieWinks />} />
            <Route path="/saltie-shout-outs" element={<SaltieShoutOuts />} />
            <Route path="/our-cow-munity" element={<OurCowmunity />} />
            <Route path="/moo-velous" element={<MooVelous />} />
            <Route path="/saltie-fun-facts" element={<SaltieFunFacts />} />
            <Route path="/coloring" element={<Coloring />} />
            <Route path="/meet-the-family" element={<MeetTheFamily />} />
            <Route path="/front-porch" element={<FrontPorch />} />
            <Route path="/salt-block" element={<SaltBlock />} />
            <Route path="/his-story" element={<HisStory />} />
            <Route path="/story-barn" element={<StoryBarn />} />
            <Route path="/story-barn/order-complete" element={<OrderComplete />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/qr" element={<QRLanding />} />
            <Route path="/qr-maker" element={<QRGenerator />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </PageTransition>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App relative">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <Toaster position="bottom-center" toastOptions={{ style: { background: "#F7F0E4", color: "#2C2724", border: "1px solid #A87149", fontFamily: "Lora, serif" } }} />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/subscribers" element={<AdminSubscribers />} />
          <Route path="/admin/cow-munity" element={<AdminCowmunity />} />
          <Route path="*" element={<StoryShell />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
